module.exports = __webpack_public_path__ + "img/2BB.1.63df81f2.jpg";